/* eslint-disable no-underscore-dangle */
import getEnvValue from 'commons/getEnvValue';
import isClient from 'commons/isClient';

const isRunningOnClient = isClient();

const Inspector = isRunningOnClient ? require('avo-inspector') : null;

const version = isRunningOnClient
  ? getEnvValue('NEXT_PUBLIC_VERSION') ?? getEnvValue('REACT_APP_VERSION')
  : '';

const avoInspector = isRunningOnClient
  ? new Inspector.AvoInspector({
      apiKey: '0LwnxMrVza9UwOgaWeUP',
      env:
        version === 'development' || version === 'test'
          ? 'dev'
          : version === 'production'
          ? 'prod'
          : version,
      version: '1.0.0',
      appName: 'My App',
    })
  : null;

export default avoInspector;
